import { gsap } from "gsap";
import { CSSRulePlugin } from "gsap/CSSRulePlugin";
import { EaselPlugin } from "gsap/EaselPlugin";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { PixiPlugin } from "gsap/PixiPlugin";
import { TextPlugin } from "gsap/TextPlugin";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const envirionment = process.env.APP_ENV;
var debug = false;
var extras_debug = false;

if (envirionment == "local") {
    debug = true;
    extras_debug = true;
}

var fixed = document.getElementById("apple");
var box = document.getElementById("box");

document.addEventListener("DOMContentLoaded", function (event) {
    window.onload = function () {
        initPage();
        gsap.from("#scroller", { autoAlpha: 0 });
        gsap.to("#loader", { autoAlpha: 0, delay: 0.5 });
    };
});

gsap.registerPlugin(
    CSSRulePlugin,
    EaselPlugin,
    MotionPathPlugin,
    PixiPlugin,
    TextPlugin,
    ScrollToPlugin,
    ScrollTrigger
);

ScrollTrigger.defaults({
    scroller: "#scroller",
    markers: debug,
    ease: "none",
});
ScrollTrigger.saveStyles(".container-hero div");

ScrollTrigger.config({
    autoRefreshEvents: "visibilitychange,DOMContentLoaded,load",
});

ScrollTrigger.refresh();

function initPage() {
    ScrollTrigger.matchMedia({
        "(max-width: 799px)": function () {
            const canvas = document.getElementById("apple");
            const context = canvas.getContext("2d");

            canvas.width = 222;
            canvas.height = 263;

            const img = new Image();
            img.onload = render;
            img.src = "/storage/images/apple_small.png";

            function render() {
                context.clearRect(0, 0, canvas.width, canvas.height);
                context.drawImage(img, 0, 0);
            }

            var tl = gsap
                .timeline({
                    defaults: {
                        ease: "none",
                        rotation: 20,
                        duration: 2,
                    },
                    scrollTrigger: {
                        trigger: "#container",
                        markers: debug,
                        start: "center center",
                        end: () => `+=${container.offsetHeight}`,
                        scrub: true,
                    },
                })
                .fromTo(
                    "#apple",
                    {
                        rotation: 10,
                        scale: 0.25,
                        x: 0,
                        y: -65,
                    },
                    {
                        rotation: -20,
                        scale: 0.9,
                        x: 0,
                        y: 50,
                    },
                    0
                );

            gsap.timeline({
                scrollTrigger: {
                    trigger: "#block1",
                    markers: debug,
                    start: "center center",
                    end: () => `+=${block1.offsetHeight}`,
                    scrub: true,
                },
            }).to("#apple", {
                y: 0,
                rotation: -10,
            });

            gsap.timeline({
                scrollTrigger: {
                    trigger: "#block2",
                    markers: debug,
                    start: "center center",
                    end: () => `+=${block2.offsetHeight}`,
                    scrub: true,
                    pin: true,
                },
            }).to("#apple", {
                rotation: 5,
            });

            gsap.timeline({
                scrollTrigger: {
                    trigger: "#block3",
                    markers: debug,
                    start: "center center",
                    end: () => `+=${block3.offsetHeight}`,
                    scrub: true,
                },
            }).to("#apple", {
                rotation: 20,
                x: -150,
                y: -10,
            });

            gsap.timeline({
                scrollTrigger: {
                    trigger: "#block5",
                    markers: debug,
                    start: "center center",
                    end: "bottom 50%",
                    scrub: true,
                },
            }).to("#apple", {
                rotation: -20,
                x: 0,
                scale: 0.4,
                y: 225,
            });

            gsap.timeline({
                scrollTrigger: {
                    trigger: "#block6",
                    markers: debug,
                    start: "center center",
                    end: () => `-=${bucket.offsetHeight}`,
                    scrub: true,
                },
            })
                .from("#apple", {
                    opacity: 100,
                })
                .to("#apple", {
                    rotation: 0,
                    opacity: 0,
                });

            var appleMove = gsap.to(".half-apple", {
                duration: 1,
                x: 0,
                rotation: 0,
                ease: "power1.out",
                paused: true,
                // scrub: true,
                delay: 0.2,
                immediateRender: true,
            });

            ScrollTrigger.create({
                trigger: "#block3",
                start: "top 50%",
                markers: extras_debug,
                onEnter: (isActive) => appleMove.play(),
                onLeave: (isActive) => appleMove.reverse(),
                onLeaveBack: (isActive) => appleMove.reverse(),
                onEnterBack: (isActive) => appleMove.play(),
            });
        },
        "(min-width: 800px)": function () {
            const canvas = document.getElementById("apple");
            const context = canvas.getContext("2d");

            canvas.width = 422;
            canvas.height = 525;

            const img = new Image();
            img.onload = render;
            img.src = "/storage/images/apple.png";

            function render() {
                context.clearRect(0, 0, canvas.width, canvas.height);
                context.drawImage(img, 0, 0);
            }

            gsap.timeline({
                defaults: { rotation: 20, scale: 0.3 },
                scrollTrigger: {
                    trigger: "#container",
                    start: "center center",
                    end: () => `+=${container.offsetHeight}`,
                    scrub: true,
                    pin: false,
                },
            }).fromTo(
                "#apple",
                {
                    rotation: 0,
                    scale: 0.3,
                    x: 260,
                    y: -20,
                },
                {
                    rotation: -30,
                    scale: 0.7,
                    x: 0,
                    y: -20,
                }
            );

            gsap.timeline({
                scrollTrigger: {
                    trigger: "#block1",
                    markers: debug,
                    start: "center center",
                    end: () => `+=${block1.offsetHeight}`,
                    scrub: true,
                    pin: false,
                },
            }).to("#apple", {
                y: -175,
                rotation: 15,
            });

            gsap.timeline({
                scrollTrigger: {
                    trigger: "#block2",
                    markers: debug,
                    start: "center center",
                    end: () => `+=${block2.offsetHeight}`,
                    scrub: true,
                    pin: false,
                },
            }).to("#apple", {
                y: 0,
                rotation: 0,
            });

            gsap.timeline({
                scrollTrigger: {
                    trigger: "#block3",
                    markers: debug,
                    start: "center center",
                    endTrigger: "#branch",
                    end: () => `+=${block3.offsetHeight}`,
                    scrub: true,
                    pin: false,
                },
            }).to("#apple", {
                rotation: 15,
                y: 0,
            });

            gsap.timeline({
                scrollTrigger: {
                    trigger: "#block5",
                    markers: debug,
                    start: "center center",
                    end: () => `+=${block5.offsetHeight}`,
                    scrub: true,
                    pin: false,
                },
            }).to("#apple", {
                rotation: -10,
                y: 0,
            });

            gsap.timeline({
                scrollTrigger: {
                    trigger: "#block6",
                    markers: debug,
                    start: "top 50%",
                    end: () => `${bucket}`,
                    scrub: true,
                    pin: false,
                },
            }).to("#apple", {
                rotation: 0,
                y: 400,
                scale: 0.2,
                opacity: 0,
            });

            var appleMove = gsap.to(".half-apple", {
                duration: 2,
                x: 0,
                rotation: 0,
                ease: "ease.in",
                paused: true,
                // scrub: true,
                delay: 1,
                immediateRender: true,
            });

            ScrollTrigger.create({
                trigger: "#block3",
                start: "top center",
                end: "bottom 50%",
                markers: extras_debug,
                onEnter: (isActive) => appleMove.play(),
                onLeave: (isActive) => appleMove.reverse(),
                onLeaveBack: (isActive) => appleMove.reverse(),
                onEnterBack: (isActive) => appleMove.play(),
            });

            // GSDevTools.create({ animation: appleMove });
        },
    });

    // =============================
    // Parallex
    // =============================

    gsap.timeline({
        scrollTrigger: {
            trigger: "#block2",
            start: "top 50%",
            end: "bottom 50%",
            markers: extras_debug,
            scrub: true,
            pin: false,
        },
        defaults: { ease: "none", duration: 4, delay: 0 },
    }).fromTo(
        "#droplets-2",
        10,
        {
            y: 900,
        },
        {
            y: 0,
            repeat: 0,
        }
    );

    gsap.timeline({
        scrollTrigger: {
            trigger: "#container",
            start: "top 50%",
            end: "bottom 50%",
            markers: extras_debug,
            scrub: true,
            pin: false,
        },
        defaults: { ease: "none", y: 0, duration: 2, delay: 0.1 },
    }).fromTo(
        "#droplets-c1",
        5,
        {
            y: -100,
            repeat: 0,
        },
        {
            y: 100,
            repeat: 0,
        }
    );

    gsap.timeline({
        scrollTrigger: {
            trigger: "#container",
            start: "top 50%",
            end: "bottom 50%",
            markers: extras_debug,
            scrub: true,
            pin: false,
        },
        defaults: { ease: "none", duration: 2, delay: 0.1 },
    }).fromTo(
        "#droplets-c2",
        5,
        {
            y: 100,
        },
        {
            y: -100,
            repeat: 0,
        }
    );

    gsap.timeline({
        scrollTrigger: {
            trigger: "#block3",
            start: "top 50%",
            end: "bottom 50%",
            markers: extras_debug,
            scrub: true,
            pin: false,
        },
        defaults: { ease: "none", duration: 1, delay: 0.1 },
    }).fromTo(
        "#droplets-c3",
        5,
        {
            y: 200,
        },
        {
            y: -200,
            repeat: 0,
        }
    );

    gsap.timeline({
        scrollTrigger: {
            trigger: "#block5",
            start: "top 50%",
            end: "bottom 50%",
            markers: extras_debug,
            scrub: true,
            pin: false,
        },
        defaults: { ease: "none", duration: 1, delay: 2 },
    }).from("#branch-blur", 10, {
        y: -100,
    });

    // =============================
    // Hide Apple
    // =============================

    gsap.timeline({
        defaults: { ease: "none" },
        scrollTrigger: {
            trigger: "#bucket",
            markers: extras_debug,
            start: "top 50%",
            end: () => `+=${bucket.offsetHeight}`,
            scrub: true,
            pin: false,
        },
    }).to("#apple", {
        opacity: 0,
    });

    gsap.timeline({
        defaults: { ease: "none", opacity: 0, scale: 0.7 },
        scrollTrigger: {
            trigger: "#bucket",
            start: "bottom bottom",
            scrub: true,
            pin: false,
            toggleClass: { targets: "#apple", className: "hidden" },
        },
    });

    // =============================
    // Apple Stats
    // =============================

    gsap.timeline({
        defaults: { ease: "none", duration: 2, delay: 2, yoyo: true },
        scrollTrigger: {
            trigger: "#block2",
            start: "top center",
            end: "center center",
            markers: extras_debug,
            scrub: true,
        },
    }).to("#theGradient stop", {
        attr: { offset: "0%" },
    });

    gsap.timeline({
        defaults: { ease: "none", duration: 2, delay: 2, yoyo: true },
        scrollTrigger: {
            trigger: "#block2",
            start: "top center",
            end: "center center",
            markers: extras_debug,
            scrub: true,
        },
    }).to("#theGradient1 stop", {
        attr: { offset: "0%" },
    });

    gsap.timeline({
        defaults: { ease: "none", duration: 2, delay: 2, yoyo: true },
        scrollTrigger: {
            trigger: "#block2",
            start: "top center",
            end: "center center",
            markers: extras_debug,
            scrub: true,
        },
    }).to("#theGradient2 stop", {
        attr: { offset: "30%" },
    });

    // =============================
    // Rotate Text
    // =============================

    var rotateText = gsap.timeline().to("#masterTextPath5", {
        attr: { startOffset: "0" },
        motionPath: {
            path: "#master",
            align: "#master",
            alignOrigin: [0.5, 0.5],
        },
        ease: "none",
        repeat: -1,
        duration: 20,
    });

    var circleText = gsap.timeline({ paused: true }).add(rotateText, 0);

    ScrollTrigger.create({
        trigger: "#block3",
        start: "top center",
        pin: false,
        markers: extras_debug,
        onEnter: (isActive) => circleText.play(),
        onLeave: (isActive) => circleText.pause(),
        onLeaveBack: (isActive) => circleText.pause(),
        onEnterBack: (isActive) => circleText.play(),
    });

    // =============================
    // Rolling Text
    // =============================

    gsap.set(".wrapper", { xPercent: -50, yPercent: -50 });

    var boxWidth = 650,
        totalWidth = boxWidth * 6, //  * n of boxes
        wrapperRollingText = document.querySelectorAll(
            "#wrapperRollingText .slide"
        ),
        dirFromLeft = "+=" + totalWidth,
        dirFromRight = "-=" + totalWidth;

    var mod = gsap.utils.wrap(0, totalWidth);

    function marquee(which, time, direction) {
        gsap.set(which, {
            x: function (i) {
                return i * boxWidth;
            },
        });
        var action = gsap.timeline().to(which, {
            x: direction,
            modifiers: {
                x: (x) => mod(parseFloat(x)) + "px",
            },
            duration: time,
            ease: "none",
            repeat: -1,
        });
        return action;
    }

    // =============================

    var master = gsap
        .timeline({ paused: true })
        .add(marquee(wrapperRollingText, 30, dirFromRight), 0);

    ScrollTrigger.create({
        trigger: "#friends",
        start: "top center",
        onEnter: (isActive) => master.play(),
        onLeave: (isActive) => master.pause(),
        onLeaveBack: (isActive) => master.pause(),
        onEnterBack: (isActive) => master.play(),
        markers: extras_debug,
        onUpdate: (self) => {
            var speed = self.progress.toFixed(2) * 2;
            master.timeScale(speed);
        },
    });
}
